import { useEffect } from 'react';
import carSeat from '~/assets/icons/car_seat.svg';
import doors from '~/assets/icons/doors.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useReset } from '../../hooks';
import {
	setSectionIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { CategoryTypes } from '../CategoryTab';
import {
	StyledButtonContent,
	StyledButtonsContainer,
} from './ColorTypeSelector.styled';

const ColorTypeSelector = () => {
	const dispatch = useLayoutDispatch();
	const sectionIndex = useLayoutSelector(
		(state) => state.colorPicker.sectionIndex,
	);
	const activeCategory = useLayoutSelector(
		(state) => state.carPaint.activeCategory,
	);
	const { handleResetBodyColor, handleResetInteriorColor } = useReset();

	useEffect(() => {
		if (sectionIndex === 0) {
			handleResetInteriorColor();
			return;
		}

		handleResetBodyColor();
	}, [sectionIndex, handleResetInteriorColor, handleResetBodyColor]);

	if (activeCategory !== CategoryTypes.PaintingWorks) {
		return null;
	}

	return (
		<StyledButtonsContainer>
			<Button
				color={sectionIndex === 0 ? ButtonColors.Select2 : ButtonColors.Default}
				height={ButtonHeight.Height50}
				style={{ fontSize: 16 }}
				onClick={() => dispatch(setSectionIndex(0))}
			>
				<StyledButtonContent>
					<img src={doors} />
					<Text>Основной цвет</Text>
				</StyledButtonContent>
			</Button>
			<Button
				color={sectionIndex === 1 ? ButtonColors.Select2 : ButtonColors.Default}
				height={ButtonHeight.Height50}
				style={{ fontSize: 16 }}
				onClick={() => dispatch(setSectionIndex(1))}
			>
				<StyledButtonContent>
					<img src={carSeat} />
					<Text>Второй цвет</Text>
				</StyledButtonContent>
			</Button>
		</StyledButtonsContainer>
	);
};

export { ColorTypeSelector };
